import { Tabs } from '@usealloy/component-library';

import { RiskRatingCard } from '../../RiskRatingCard/RiskRatingCard';
import { RiskScoreTabLabel } from '../../RiskRatingCard/RiskScoreTabLabel';
import type { CoreRiskData } from '../../RiskRatingCard/useRiskData';
import { useEventTypeEvaluationsContext } from '../context';
import { ExternalAccountCreatedOverview } from './ExternalAccountCreatedOverview';

interface ExternalAccountCreatedTabsProps {
  riskData: CoreRiskData;
  canViewRiskFormula: boolean;
}

export const ExternalAccountCreatedTabs = ({
  riskData,
  canViewRiskFormula,
}: ExternalAccountCreatedTabsProps) => {
  const { evaluation } = useEventTypeEvaluationsContext();
  const {
    riskFactors,
    riskFormula,
    riskRangeValues,
    riskRatingColor,
    riskRatingLabel,
    totalRisk,
  } = riskData;

  const tabs = [
    {
      label: 'Overview',
      value: 'overview',
      content: <ExternalAccountCreatedOverview />,
    },
    {
      label: (
        <RiskScoreTabLabel
          riskRatingColor={riskRatingColor}
          riskRatingLabel={riskRatingLabel}
        />
      ),
      value: 'risk-score',
      content: (
        <RiskRatingCard
          canViewRiskFormula={canViewRiskFormula}
          entityToken={evaluation.entity_token}
          evaluationToken={evaluation.evaluation_token}
          evaluationType={evaluation.evaluation_type}
          riskFactors={riskFactors}
          riskOutputFormula={riskFormula}
          riskRanges={riskRangeValues}
          riskValue={totalRisk}
          riskValueColor={riskRatingColor}
          riskValueLabel={riskRatingLabel}
          variant="entityRisk"
          workflowToken={evaluation.application_token}
          workflowVersion={evaluation.public_version}
        />
      ),
    },
  ];

  return (
    <Tabs style={{ width: '100%' }} tabs={tabs} />
  );
};
